module.exports = __webpack_public_path__ + "static/media/smartAsn-logos-BKN.9f76bbb0.svg";